import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import { CancelSubmitFormDialogActions } from 'framework/forms/CancelSubmitFormDialogActions';
import { FormExtendedRadioGroupField } from 'framework/forms/FormExtendedRadioGroupField';
import { handleValidateResponseBase } from 'framework/forms/utils/handleValidateResponseBase';
import { useFormSubmit } from 'framework/hooks/useFormSubmit';
import { useSnackbarNotify } from 'framework/hooks/useSnackbarNotify';
import {
	ExactOnlineCostCenterMode,
	IExactOnlineSettingsDto,
	IPatchExactOnlineCostCenterModeRequest,
	exactOnlineSettingsCommand_patchCostCenterMode,
} from 'gen/ApiClient';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import * as yup from 'yup';

const createSchema = (_: IStrings) => {
	return yup.object<IPatchExactOnlineCostCenterModeRequest>({
		mode: yup.mixed<ExactOnlineCostCenterMode>().required(),
	});
};

interface IProps extends DialogProps {
	item: IExactOnlineSettingsDto;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

// TODO
export const PatchExactOnlineCostCenterModeForm = ({ item, confirm, cancel, ...rest }: IProps) => {
	const [submit, isSubmitting] = useFormSubmit(exactOnlineSettingsCommand_patchCostCenterMode);
	const strings = useLocalization();
	const notify = useSnackbarNotify();

	const handleSubmit = async (values: IPatchExactOnlineCostCenterModeRequest, helpers: FormikHelpers<IPatchExactOnlineCostCenterModeRequest>) => {
		const r = await submit(values);
		handleValidateResponseBase(r, e => notify(e, 'error'), confirm);
	};

	return (
		<Formik<IPatchExactOnlineCostCenterModeRequest>
			validateOnMount
			initialValues={{
				mode: item.costCenterMode,
			}}
			validationSchema={createSchema(strings)}
			onSubmit={handleSubmit}>
			<Form>
				<Dialog
					fullWidth
					{...rest}>
					<DialogTitle>{strings.changeWhat(strings.type)}</DialogTitle>
					<DialogContent
						dividers
						className='df-col'>
						<FormExtendedRadioGroupField<IPatchExactOnlineCostCenterModeRequest, ExactOnlineCostCenterMode>
							label={strings.mode}
							name='mode'
							options={[
								{ value: 'FillIn', label: `Invullen`, caption: `Kostenplaats invullen op verkoopslijn` },
								{ value: 'DontFillIn', label: `Niet invullen`, caption: `Kostenplaats niet invullen op verkoopslijn` },
							]}
						/>
					</DialogContent>
					<CancelSubmitFormDialogActions
						cancel={cancel}
						isSubmitting={isSubmitting}
						submitText={strings.update}
					/>
				</Dialog>
			</Form>
		</Formik>
	);
};
